import { freddyTheme } from '@coolblue-development/freddy';
import { containerHeight } from '../constants.js';
export const getVideoContainerStyles = ({ size, isOverlay, }) => ({
    alignItems: 'center',
    '> div': {
        maxHeight: '100%',
    },
    ...(typeof size === 'string' && {
        height: !isOverlay ? containerHeight[size] : 'initial',
    }),
    ...(typeof size === 'object' && {
        ...['xs', 'sm', 'md', 'lg', 'xl'].reduce((styles, breakpoint) => {
            return {
                ...styles,
                ...(size[breakpoint] && {
                    [breakpoint === 'xs'
                        ? freddyTheme.breakpoint.maxWidth('sm')
                        : freddyTheme.breakpoint.minWidth(breakpoint)]: {
                        height: !isOverlay
                            ? containerHeight[size[breakpoint]]
                            : 'initial',
                    },
                }),
            };
        }, {}),
    }),
});
//# sourceMappingURL=MediaGalleryVideoContainer.styles.js.map